import { type SummaryData, type SummaryDataProvider } from "~/Configurators/Shaft/SummaryDataProvider";

import classes from "./InchShaftSummaryData.module.less";
import classNames from "classnames";
import { createContext, type ReactNode, useContext } from "react";
import { Stacker } from "~/common/components/Stacker/Stacker";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

export function renderSummary(data?: SummaryData, colSpan?: number) {
  return (
    <>
      <td colSpan={colSpan}>{data?.name}</td>
      <td colSpan={colSpan}>{renderValue(data)}</td>
    </>
  );
}

export function renderValue(data?: Omit<SummaryData, "name">) {
  if (!data) {
    return null;
  }
  return (
    <Stacker direction={"row"} gap={8} className={"d-flex flex-align-center"}>
      {data.isStandard && <Icon type={IconType.Star} className={"f-green"} size={15} />}
      {data.value}
    </Stacker>
  );
}
export function renderStep2MachiningValue(data?: SummaryData) {
  if (!data) {
    return null;
  }
  return (
    <Stacker direction={"row"} gap={8}>
      {data.isStandard && <Icon type={IconType.Star} className={"f-green"} size={15} />}
      {data.value}
      {data.name}
    </Stacker>
  );
}

export const Table = ({ children, colAmount = 6 }: { children?: ReactNode; colAmount?: number }) => {
  return (
    <table className={classNames(classes.table)}>
      <colgroup>
        {Array.from({ length: colAmount }, (_, index) => (
          <col key={index} />
        ))}
      </colgroup>
      {children}
    </table>
  );
};

const SummaryProviderContext = createContext<SummaryDataProvider | null>(null);

export const SummaryProviderContextProvider = SummaryProviderContext.Provider;

export const useSummaryProvider = () => {
  const summaryProvider = useContext(SummaryProviderContext);
  if (!summaryProvider) {
    throw new Error("SummaryProviderContext is not provided");
  }
  return summaryProvider;
};
